export default __webpack_public_path__ + "static/media/RPB_JC.1fdcddaf.png";